module.exports = __webpack_public_path__ + "img/truck-tow.de578e6c.svg";